import initialState from './initial_state'
import * as types from '../actions/action_types'

export default function (state = initialState.reducerQuestions, action) {

    // console.log("SSSS:", action)

    switch (action.type) {
        case types.ITEM_LIST_QUESTIONS_FULFILLED:
            return {
                itemListQuestions: action.payload ? action.payload.data.results : [{}],
                isitemListQuestionsLoaded: true
            }

        default:
            return state
    }
}
